import React from 'react' 
import { Link } from 'gatsby'
import SelectLanguage from './SelectLanguage'
import logo from '../img/logoBoAtitre.svg'
import { FormattedMessage } from 'react-intl';

function toggleBurgerMenu() {
  var burger = document.querySelector('.burger');
  var nav = document.querySelector('#'+burger.dataset.target);
  burger.classList.toggle('is-active');
  nav.classList.toggle('is-active');
}

const Navbar = (props) => (
  <nav className="navbar is-fixed-top">
    <div className="container">
      <div className="navbar-brand">
        <Link to={props.locale + '/'} className="navbar-item">
          <figure className="image">
            <img src={logo} alt="BoA" style={{ width: '100px' }} />
          </figure>
        </Link>
        <span className="navbar-burger burger" data-target="navMenu" onClick={toggleBurgerMenu}>
          <span></span>
          <span></span>
          <span></span>
        </span>
      </div>
      <div id="navMenu" className="navbar-menu">
        <div className="navbar-start">
          <div className="navbar-item has-dropdown is-hoverable">
            <Link className="navbar-item" to={props.locale + '/boa'}>
              <FormattedMessage id="navBoaSoftware" />
            </Link>
            <div className="navbar-dropdown">
              <Link className="navbar-item" to={props.locale + '/boa'}>
                <FormattedMessage id="navPresentation" />
              </Link>
              <Link className="navbar-item" to={props.locale + '/boa/characteristics'}>
                <FormattedMessage id="navCharacteristics" />
              </Link>
              <Link className="navbar-item" to={props.locale + '/boa/compatibility'}>
                <FormattedMessage id="navCompatibility" />
              </Link>
              <hr className="navbar-divider" />
              <Link className="navbar-item" to={props.locale + '/boa/downloads'}>
                <FormattedMessage id="navDownloads" />
              </Link>
            </div>
          </div>
          <Link className="navbar-item" to={props.locale + '/pricing'}>
            <FormattedMessage id="navPricing" />
          </Link>
          <div className="navbar-item has-dropdown is-hoverable">
            <Link className="navbar-item" to={props.locale + '/versions'}>
              <FormattedMessage id="navVersions" />
            </Link>
            <div className="navbar-dropdown">
              <Link className="navbar-item" to={props.locale + '/versions'}>
                <FormattedMessage id="navNumbering" />
              </Link>
              <hr className="navbar-divider" />
              <Link className="navbar-item" to={props.locale + '/versions/boa-4_2'}>
                <FormattedMessage id="navBoA-4_2" />
              </Link>
              <Link className="navbar-item" to={props.locale + '/versions/4_2-4_3'}>
                <FormattedMessage id="nav4_2-4_3" />
              </Link>
              <Link className="navbar-item" to={props.locale + '/versions/boa-4_3'}>
                <FormattedMessage id="navBoA-4_3" />
              </Link>
              <Link className="navbar-item" to={props.locale + '/versions/boa-4_3-localized'}>
                <FormattedMessage id="navBoA-4_3Localized" />
              </Link>
              <Link className="navbar-item" to={props.locale + '/versions/boa-4_4'}>
                <FormattedMessage id="navBoA-4_4" />
              </Link>
            </div>
          </div>
          <div className="navbar-item has-dropdown is-hoverable">
            <Link className="navbar-item" to={props.locale + '/documentation'}>
              <FormattedMessage id="navDocumentation" />
            </Link>
            <div className="navbar-dropdown">
              <Link className="navbar-item" to={props.locale + '/documentation'}>
                <FormattedMessage id="navManuals" />
              </Link>
              <Link className="navbar-item" to={props.locale + '/documentation/tutorials'}>
                <FormattedMessage id="navTutorials" />
              </Link> 
              <hr className="navbar-divider" />
              <Link className="navbar-item" to={props.locale + '/documentation/images'}>
                <FormattedMessage id="navImages" />
              </Link>
              <Link className="navbar-item" to={props.locale + '/documentation/hatching'}>
                <FormattedMessage id="navHatching" />
              </Link>
            </div>
          </div>
        </div>
        <div className="navbar-end">
          <Link className="navbar-item" to={props.locale + '/contact'}>
            <FormattedMessage id="navContact" />
          </Link>
          <a className="navbar-item" href="http://forum.boa-research.fr/" target="_blank" rel="noopener noreferrer">
            <FormattedMessage id="navForum" />
          </a>
          <Link className="navbar-item" to={props.locale + '/links'}>
            <FormattedMessage id="navLinks" />
          </Link>
          <SelectLanguage langs={props.langs} />
        </div>
      </div>
    </div>
  </nav>
)

export default Navbar
